import {
  Box,
  Container,
  Typography,
  useTheme,
  Paper,
  Grid,
} from "@mui/material";
import ContactInformation from "./contactInformation";
import BudgetForm from "./budgetForm";
import { motion } from "framer-motion";

export default function ContactUs() {
  const theme = useTheme();


  return (
    <Box
      sx={{
        py: { xs: 4, md: 8 },
        backgroundColor: theme.palette.background.default,
        minHeight: "100vh",
      }}
    >
      <Container maxWidth="lg">
        {/* Header Section */}
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: "bold",
              color: theme.palette.primary.main,
            }}
          >
            Entre em Contato Conosco
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: theme.palette.text.secondary,
              maxWidth: "600px",
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            Tem alguma dúvida ou precisa de mais informações? Nossa equipe está
            pronta para ajudar!
          </Typography>
        </Box>

        {/* Free Consultation Banner */}
        <Paper
          elevation={0}
          sx={{
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.primary.contrastText,
            p: 3,
            mb: 6,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <Typography variant="h4" component="h1" sx={{ fontWeight: "bold", mb: 4, color: theme.palette.info.main }}>
            Orçamentos e Consultoria Gratuitos!
          </Typography>
          <Typography variant="body1">
            Todos os nossos orçamentos e consultoria são gratuitos. Vamos até
            sua casa e dedicamos tempo para desenvolver seu projeto
            personalizado.
          </Typography>
        </Paper>

        {/* Main Content Container */}
        <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
          <Grid container spacing={4} alignItems="stretch">
            <Grid size={{ xs: 12, md: 6 }}>
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <ContactInformation />
              </motion.div>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
              >
                <BudgetForm />
              </motion.div>
            </Grid>
          </Grid>
        </Container>
      </Container>
    </Box>
  );
}
